// Variant resolver for the persistent mobile bottom tab bar. This pattern
// only exists for `pet` today — every other industry resolves to a no-op so
// rendering <MobileTabBar /> from DefaultLayout is safe for all industries.
import { useIndustry } from '@/app/providers/industry-context.js';
import MobileTabBarPet from './MobileTabBar.pet.jsx';
import MobileTabBarDefault from './MobileTabBar.default.jsx';

function MobileTabBarNoop() {
  return null;
}

const registry = {
  pet: MobileTabBarPet,
  default: MobileTabBarDefault,
};

export default function MobileTabBar(props) {
  const { key } = useIndustry();
  const Component = registry[key] ?? MobileTabBarNoop;
  return <Component {...props} />;
}
